import script from "./VenueList.vue?vue&type=script&setup=true&lang=js"
export * from "./VenueList.vue?vue&type=script&setup=true&lang=js"

import "./VenueList.vue?vue&type=style&index=0&id=5e1cf53d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e1cf53d"]])

export default __exports__